var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurntable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 14,
    viewBox: "0 0 29 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0357 10.0181C23.5 10.0181 28 7.90546 28 6.01256C28 3.70479 21.9558 1.83398 14.5 1.83398C7.04416 1.83398 1 3.70479 1 6.01256C1 8.04815 6.46429 10.0181 12.8929 10.0181M10.9643 6.97684L14.1786 10.1911L11.2857 13.084",
    stroke: "white",
    strokeWidth: 1.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurntable);
export default __webpack_public_path__ + "static/media/turntable.ce9608eebb00a6aabeabfafa471b8e10.svg";
export { ForwardRef as ReactComponent };